import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface ConfirmModalProps {
	open: boolean;
	onClose: () => void;
	onSumbit: () => void;
	title: string;
	description: string;
}

export function ConfirmModal({
	open,
	onClose,
	onSumbit,
	title = "Confirm",
	description = "Are you sure you want to confirm this action?",
}: ConfirmModalProps): React.JSX.Element {
	const [isSubmitting, setIsSubmitting] = React.useState(false);

	const handleSumbit = async () => {
		setIsSubmitting(true);

		try {
			await onSumbit();
		} catch (error) {
			console.log(error);
		} finally {
			onClose();
			setIsSubmitting(false);
		}
	};

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogContent sx={{ p: 3 }}>
				<Stack direction="row" spacing={2} sx={{ display: "flex" }}>
					<Stack spacing={3}>
						<Stack spacing={1}>
							<Typography variant="h5">{title}</Typography>
							<Typography color="text.secondary" variant="body2">
								{description}
							</Typography>
						</Stack>
					</Stack>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ p: 3, pt: 0 }}>
				<Stack direction="row" spacing={2} sx={{ justifyContent: "flex-end" }}>
					<Button color="secondary" onClick={onClose}>
						Cancel
					</Button>
					<Button color="primary" variant="contained" onClick={handleSumbit} disabled={isSubmitting}>
						Confirm
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
